import { useMemo, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ComicCard from "@/components/feature/ComicCard";
import { comics, categories } from "@/mocks/comics";

export default function Category() {
  const [active, setActive] = useState("all");
  const [keyword, setKeyword] = useState("");

  const allCats = [{ key: "all", name: "全部" }, ...categories];

  const list = useMemo(() => {
    let result = active === "all" ? comics : comics.filter((c) => c.category === active);
    if (keyword.trim()) {
      const kw = keyword.trim();
      result = result.filter(
        (c) => c.title.includes(kw) || c.tagline.includes(kw) || c.description.includes(kw)
      );
    }
    return result;
  }, [active, keyword]);

  const count = (key: string) =>
    key === "all" ? comics.length : comics.filter((c) => c.category === key).length;

  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />

      <section className="bg-gradient-to-b from-background-100 to-background-50 border-b border-background-200 pt-24 pb-10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950">
            全部漫画作品
          </h1>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            喵趣漫画汇集喵趣漫画养猫日常、生活日常与日常趣事等作品，轻松日常持续更新，找到你喜欢的养猫日常漫画。
          </p>
          <div className="mt-6 mx-auto max-w-xl">
            <div className="flex items-center gap-2 rounded-full bg-background-50 border border-background-200 px-4 py-2.5 focus-within:border-primary-300">
              <i className="ri-search-line text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画标题、简介…"
                className="flex-1 bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-500"
              />
              {keyword && (
                <button
                  onClick={() => setKeyword("")}
                  aria-label="清空"
                  className="text-foreground-400 cursor-pointer"
                >
                  <i className="ri-close-circle-line"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-nowrap md:flex-wrap md:pb-0">
          {allCats.map((cat) => (
            <button
              key={cat.key}
              onClick={() => setActive(cat.key)}
              className={`px-5 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                active === cat.key
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {cat.name}
              <span className={`ml-1.5 text-xs ${active === cat.key ? "text-background-50/80" : "text-foreground-500"}`}>
                {count(cat.key)}
              </span>
            </button>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-between">
          <p className="text-sm text-foreground-600">
            共找到 <span className="font-medium text-foreground-950">{list.length}</span> 部作品
          </p>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-foreground-600">
            <i className="ri-sparkling-line text-accent-500"></i> 轻松日常 · 持续更新
          </span>
        </div>

        {list.length > 0 ? (
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {list.map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>
        ) : (
          <div className="mt-16 text-center">
            <i className="ri-search-eye-line text-5xl text-foreground-300"></i>
            <p className="mt-4 font-heading text-xl text-foreground-950">没有找到匹配的作品</p>
            <p className="mt-2 text-sm text-foreground-600">换个关键词或分类试试吧</p>
            <button
              onClick={() => { setKeyword(""); setActive("all"); }}
              className="mt-6 rounded-full bg-primary-500 text-background-50 text-sm px-6 py-2.5 whitespace-nowrap cursor-pointer"
            >
              重置筛选
            </button>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}